export default __webpack_public_path__ + "static/media/step2.9a58b60a.png";